/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGatedContentCheckedFields } from 'selectors';
import { useGetMemberTypesQuery } from 'store/api/version-api.slice';

// options is array of member types => []
const GatedContent = ({ handleChange }) => {
	const { data = {} } = useGetMemberTypesQuery();

	const savedCheckedFields = useSelector(getGatedContentCheckedFields);

	const memberTypes = useMemo(() => data.results || [], [data.results]);

	const [memberTypesState, setMemberTypesState] = useState([]);

	useEffect(() => {
		if (memberTypes) {
			const memberTypeItems = memberTypes.map(type => ({
				...type,
				checked: savedCheckedFields.some(field => field.memberTypeId === type.id)
			}));

			setMemberTypesState(memberTypeItems);
		}
	}, [memberTypes, savedCheckedFields]);

	const handleCheck = id => event => {
		const checkedFields = memberTypesState.map(field => {
			const newField = { ...field };
			if (newField.id === id) {
				newField.checked = event.target.checked;
			}

			return newField;
		});

		setMemberTypesState(checkedFields);

		handleChange(checkedFields);
	};

	return (
		<Grid container spacing={2} sx={{ display: 'flex', padding: '16px' }}>
			<Grid item sm={12} xs={12}>
				<Paper sx={{ padding: '16px' }}>
					<Typography component={'span'} color="primary" variant="h6">
						GATED CONTENT
					</Typography>
					<List>
						{memberTypesState.map(field => {
							return (
								<Box key={field.id}>
									<ListItem>
										<ListItemText primary={field.member_type}></ListItemText>
										<ListItemSecondaryAction>
											<Checkbox
												edge="end"
												onChange={handleCheck(field.id)}
												checked={field.checked || false}
											/>
										</ListItemSecondaryAction>
									</ListItem>
									<Divider component="li" />
								</Box>
							);
						})}
					</List>
					<Grid container spacing={2}></Grid>
				</Paper>
			</Grid>
			<Grid item sm={6} xs={12} sx={{ display: 'flex' }}></Grid>
		</Grid>
	);
};

export default GatedContent;
